import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Users,
  TrendingUp,
  CheckCircle,
  Database,
} from "lucide-react";
import Logo from "../../utils/salesDood2.png";
import useApi from "../../hooks/useApi";

function MachineRegistration() {
  const navigate = useNavigate();
  const [companyCode, setCompanyCode] = useState("");
  const [publicKey, setPublicKey] = useState("");
  const [privateKey, setPrivateKey] = useState("");

  const [publicKeyErrorMessage, setPublicKeyErrorMessage] = useState("");
  const [privateKeyErrorMessage, setPrivateKeyErrorMessage] = useState("");

  const handleCompanyCode = (e) => {
    setCompanyCode(e.target.value);
    setPublicKeyErrorMessage("");
  };

  const handlePrivateKey = (e) => {
    setPrivateKey(e.target.value);
    setPrivateKeyErrorMessage("");
  };

  const {
    request: requestRegister,
    loading: loadingRegister,
    error: errorRegister,
  } = useApi();

  const {
    request: requestPubKey,
    loading: loadingPubKey,
    error: errorPubKey,
  } = useApi();

  const handleGetPubKey = async (e) => {
    e.preventDefault();
    if (companyCode?.length > 0) {
      const url = `${process.env.REACT_APP_BASE_URL}:199/GetPublicKey?cmpcode=${companyCode}`;

      console.log(url);

      try {
        const response = await requestPubKey({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        console.log("Raw Response:", response);
        if (response) {
          if (response?.length > 0) {
            setPublicKey(response[0].systemkey);
            setPublicKeyErrorMessage("");
          } else {
            setPublicKeyErrorMessage("invalid company code");
          }
        } else {
          setPublicKeyErrorMessage("invalid company code");
        }
      } catch (err) {
        console.error("Error:", err);
      }
    } else {
      alert("Please enter company code");
    }
  };

  const registerMachine = async (e) => {
    e.preventDefault();

    if (!privateKey || privateKey.trim() === "") {
      // setPrivateKeyErrorMessage("License number is required");
      alert("Please enter Licence number");
      return;
    }

    setPrivateKeyErrorMessage("");

    const url = `${process.env.REACT_APP_BASE_URL}:199/CheckStatus?cmpcode=${companyCode}&publick=${publicKey}&privatek=${privateKey}`;
    console.log(url);

    try {
      const registerMachineData = await requestRegister({
        url: url,
        method: "GET",
        timeout: 5000,
      });

      console.log("Response of register machine data", registerMachineData);

      if (registerMachineData?.length > 0) {
        if (registerMachineData[0].Column1 === "REGISTERED") {
          localStorage.setItem("masterCompanyCode", companyCode);
          localStorage.setItem("companyPublicKey", publicKey);
          localStorage.setItem("companyPrivateKey", privateKey);
          navigate("/");
        } else {
          setPrivateKeyErrorMessage("Invalid License Number");
        }
      } else {
        setPrivateKeyErrorMessage("Invalid License Number");
      }
    } catch (error) {
      console.log("Register Machine Error:", error);
      setPrivateKeyErrorMessage("Something went wrong. Please try again.");
    }
  };
  const stats = [
    { icon: Database, label: "Data Accuracy", value: "100%" }, // Focus on "Single Source of Truth"
    { icon: TrendingUp, label: "Conversion Rate", value: "98%" },
    // { icon: Globe, label: "Countries", value: "50+" },
    // { icon: Star, label: "Customer Rating", value: "4.9" },
  ];

  const features = [
    // "AI-Powered Lead Scoring",
    "Real-time Analytics",
    "Custom Workflows",
    "Multi-channel Integration",
    "Advanced Reporting",
    "Mobile CRM Access",
  ];

  return (
    <div>
      <div className="min-h-screen  bg-white flex items-center justify-center p-2 relative ">
        {/* Grid pattern overlay */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
            backgroundSize: "30px 30px",
          }}
        ></div>

        <div className="lg:max-w-6xl w-full  bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl overflow-hidden border border-gray-200 relative z-10 scrollbar-hide">
          <div className="grid lg:grid-cols-5 h-full">
            <div className="lg:col-span-3 p-6 lg:p-8 text-white relative overflow-hidden bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 flex flex-col">
              <div className="flex items-center mb-6">
                <div>
                  <img src={Logo} alt="" className=" h-14 " />
                </div>
              </div>

              {/* Hero Content */}
              <div className="mb-6">
                <h2 className="text-2xl lg:text-3xl font-bold mb-3 leading-tight">
                  Transform Your Sales
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-orange-300">
                    Into Success Stories
                  </span>
                </h2>
                <p className="text-blue-100 text-sm leading-relaxed max-w-md">
                  Join thousands of sales teams who trust our platform to
                  accelerate growth and maximize conversions.
                </p>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-3 mb-6">
                {stats.map((stat, index) => (
                  <div
                    key={index}
                    className="bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/20"
                  >
                    <div className="flex items-center space-x-2">
                      <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                        <stat.icon className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <div className="text-lg font-bold">{stat.value}</div>
                        <div className="text-blue-100 text-xs">
                          {stat.label}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Features List */}
              <div className="mb-6 flex-grow">
                <h3 className="font-semibold mb-3 flex items-center">
                  <CheckCircle className="w-4 h-4 mr-2 text-green-300" />
                  Key Features
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
                  {features.map((feature, index) => (
                    <div
                      key={index}
                      className="flex items-center space-x-2 text-xs text-blue-100"
                    >
                      <div className="w-1 h-1 bg-green-300 rounded-full"></div>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="pt-4 mt-auto">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/20 space-y-2">
                  <div className="flex items-center space-x-2 text-xs">
                    <Phone className="w-3 h-3 text-blue-200" />
                    <span className="text-blue-100">+971 4 2677221</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs">
                    <Mail className="w-3 h-3 text-blue-200" />
                    <span className="text-blue-100">
                      info@cubixitsolutions.com
                    </span>
                  </div>
                  <div className="flex items-start space-x-2 text-xs">
                    <MapPin className="w-3 h-3 text-blue-200 mt-0.5" />
                    <span className="text-blue-100">
                      Al Nazriya Buildings - Suite 129
                      <br />
                      Damascus Street, Al Qusais, Dubai
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Panel - Register Form */}
            <div className="lg:col-span-2 p-6 lg:p-8 bg-gradient-to-br from-gray-50 to-white flex flex-col justify-center relative">
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-l from-blue-100/50 to-transparent rounded-full -mr-12 -mt-12"></div>

              <div className="relative z-10">
                <div className="mb-6">
                  <h2 className="text-xl font-bold text-gray-900 mb-2">
                    Device Registration
                  </h2>
                  <p className="text-gray-600 text-sm">
                    Secure your device access to our platform
                  </p>
                </div>

                <div className="bg-blue-50 rounded-lg p-3 mb-6 text-sm">
                  <p className="text-blue-800 font-medium mb-1">Quick Setup:</p>
                  <p className="text-blue-700">
                    <b>1.</b> Enter company code → <b>2.</b> Generate key →{" "}
                    <b>3.</b> Get license from admin → <b>4.</b> Register
                  </p>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Company Code *
                    </label>
                    <input
                      type="text"
                      value={companyCode}
                      onChange={handleCompanyCode}
                      placeholder="Enter company code"
                      className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                  </div>

                  <button
                    onClick={handleGetPubKey}
                    disabled={loadingPubKey || !companyCode}
                    className="w-full bg-blue-600 text-white py-2.5 px-4 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium"
                  >
                    {loadingPubKey ? (
                      <span className="flex items-center justify-center space-x-2">
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        <span>Generating...</span>
                      </span>
                    ) : (
                      "Generate Device Key"
                    )}
                  </button>

                  {publicKey && (
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                      <label className="block text-sm font-medium text-green-800 mb-1">
                        Device Key (Share with Admin):
                      </label>
                      <div className="bg-white border border-green-300 rounded p-2 font-mono text-xs break-all text-green-900">
                        {publicKey}
                      </div>
                      <p className="text-xs text-green-700 mt-1">
                        Copy this key and share with your admin for license
                        number
                      </p>
                    </div>
                  )}

                  {publicKeyErrorMessage && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-2">
                      <p className="text-sm text-red-600">
                        {publicKeyErrorMessage}
                      </p>
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      License Number *
                    </label>
                    <input
                      type="text"
                      value={privateKey}
                      onChange={handlePrivateKey}
                      placeholder="Enter license from admin"
                      className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                    {privateKeyErrorMessage && (
                      <p className="mt-1 text-sm text-red-600">
                        {privateKeyErrorMessage}
                      </p>
                    )}
                  </div>

                  <button
                    onClick={registerMachine}
                    disabled={loadingRegister || !publicKey || !privateKey}
                    className="w-full bg-green-600 text-white py-2.5 px-4 rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium"
                  >
                    {loadingRegister ? (
                      <span className="flex items-center justify-center space-x-2">
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        <span>Registering...</span>
                      </span>
                    ) : (
                      "Register Device"
                    )}
                  </button>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-200 text-center">
                  <p className="text-xs text-gray-500">
                    Need help?{" "}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="mailto:info@cubixitsolutions.com"
                      className=" hover:underline"
                    >
                      info@cubixitsolutions.com
                    </a>
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    @2021 Cubix IT Solutions LLC. All rights reserved.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineRegistration;
